if (!customElements.get('pro-edition-upsell')) {
  customElements.define(
    'pro-edition-upsell',
    class ProEditionUpsell extends HTMLElement {
      constructor() {
        super();

        this.onChange = this.onChange.bind(this);
      }

      connectedCallback() {
        this.addEventListener('change', this.onChange);
        this.updateSelectedState();
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
      }

      onChange(event) {
        if (!event.target.matches('.pro-edition-upsell__radio')) return;
        this.updateSelectedState();
      }

      updateSelectedState() {
        this.querySelectorAll('.pro-edition-upsell__option').forEach((option) => {
          const input = option.querySelector('.pro-edition-upsell__radio');
          option.classList.toggle('pro-edition-upsell__option--selected', Boolean(input?.checked));
        });
      }

      get selectedOption() {
        const input = this.querySelector('.pro-edition-upsell__radio:checked');
        if (!input) return null;

        return {
          value: input.value,
          variantId: input.dataset.proVariantId || '',
          sellingPlanId: input.dataset.sellingPlanId || '',
          requiresSellingPlan: input.dataset.requiresSellingPlan === 'true',
          label: input.dataset.proLabel || input.value,
          errorMessage: input.dataset.errorMessage || '',
          disabled: input.disabled,
        };
      }
    }
  );
}
